import { jsx as ___EmotionJSX } from "@emotion/core";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// Account for the HTML "size" prop where the select resizes?
// Also "multiple"?
import * as React from "react";
import { css } from "./Theme";

const Select = props => {
  const styles = css({
    width: "100%",
    color: "font.primary",
    p: 3,
    fontSize: 1,
    boxShadow: "none",
    m: "0px",
    border: "1px solid",
    borderColor: "background.tertiary",
    borderRadius: 4,
    appearance: "none",
    background: "url(http://cdn1.iconfinder.com/data/icons/cc_mono_icon_set/blacks/16x16/br_down.png) no-repeat right 6px center white",
    "&:hover": {
      cursor: "pointer"
    }
  });
  return ___EmotionJSX("select", _extends({
    css: styles
  }, props), props.children);
};

export default Select;